var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.49.79l1,2.71h2a.49.49,0,0,1,.35.86L14.12,5.57l1,2.21a.52.52,0,0,1-.75.65L12,7.13,9.69,8.43a.52.52,0,0,1-.75-.65l1-2.21L8.17,4.36a.49.49,0,0,1,.34-.86h2l1-2.71A.54.54,0,0,1,12.49.79Z",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51,8.94l-.9.63,1,2.21a.52.52,0,0,1-.75.65L4.5,11.13l-2.32,1.3a.52.52,0,0,1-.75-.65l1-2.21L.66,8.36A.49.49,0,0,1,1,7.5H3L4,4.79a.53.53,0,0,1,.94,0L6,7.5H7",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51,8.94l.9.63-1,2.21a.52.52,0,0,0,.75.65l2.32-1.3,2.33,1.3a.52.52,0,0,0,.74-.65l-1-2.21,1.74-1.21A.49.49,0,0,0,23,7.5H21L20,4.79a.54.54,0,0,0-.95,0L18,7.5H17",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.26,14.6a5.35,5.35,0,0,0,3.88,1.65,5.29,5.29,0,0,0,2.14-.44",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.06,
    cy: 16.25,
    r: 3.25,
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.51,23.5a5.37,5.37,0,0,0-9,0",
    style: {
      fill: "none",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.b283d1f4.svg";
export { ForwardRef as ReactComponent };